import React from 'react';
import CustomCells from 'ui/structure/CustomTableCells/CustomCells';

export interface IColumn {
  Header: string;
  accessor: string;
  width: number;
}

const columns = [
  {
    Header: 'Customer ID',
    accessor: 'customerId',
    width: 120,
  },
  {
    Header: 'Card’s Last 4 Digits',
    accessor: 'cardLastDigit',
    width: 100,
  },
  {
    Header: 'Card Name',
    accessor: 'beneficiaryName',
    width: 120,
  },
  {
    Header: 'Phone Number',
    accessor: 'phoneNumber',
    width: 120,
  },
  {
    Header: 'Amount',
    accessor: 'amount',
    width: 120,
    Cell: ({
      row: {
        original: { amount },
      },
    }) => (
      <CustomCells>
        <span>{`GHS ${Number(amount).toFixed(2)}`}</span>
      </CustomCells>
    ),
  },
  {
    Header: 'Description',
    accessor: 'narration',
    width: 120,
  },
  {
    Header: 'Status',
    accessor: 'description',
    width: 260,
  },
];

export default columns;
